import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/DownloadApp.vue')
  },
  {
    path: '/CloseAccount',
    name: 'CloseAccount',
    component: () => import('../views/CloseAccount.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
